import * as React from 'react';
import cx from 'classnames';

import { Loader } from '../../../Loader/Loader';
import { VisuallyHidden } from '../../../VisuallyHidden/VisuallyHidden';

import * as cs from './EmailNewsletterFormLoader.module.css';

interface Props {
  success: boolean;
  snippet: CustomTypes.SubscribeSnippet;
  loading: boolean;
  morphingOut: boolean;
}

export const EmailNewsletterFormLoader = ({
  success,
  snippet,
  loading,
  morphingOut,
}: Props) => (
  <>
    {loading && <Loader aria-hidden={success} className={cs.loader} />}
    {success && (
      <>
        <div className={cx(cs.badge, { [cs.morphingOut]: morphingOut })} />

        <p
          className={cx(cs.tagline, { [cs.morphingOut]: morphingOut })}
          role="alert"
        >
          <VisuallyHidden>{snippet.successAria}</VisuallyHidden>
          {snippet.success}
        </p>
      </>
    )}
  </>
);
